<script setup lang="ts">
import {useI18n} from 'vue-i18n'
import { computed, inject, Ref,ref } from 'vue'
import { VyzvaSpecificationPublicResponse } from '/@src/client-public'
import { ZoppmSchemeTransformer } from '/@src/utils/zoppm'
import { NazvyAssemblySekcii } from '/@src/utils/zoppm/ZoppmSchemeTransformer/types'
export interface PartneriPrijektuProps {}

const props = defineProps<PartneriPrijektuProps>()
const {t} = useI18n()

const schemeTransformer = inject<Ref<ZoppmSchemeTransformer>>('schemeTransformer')

const sekciaRefNazov: NazvyAssemblySekcii = 'zoppm.ss.partneri-po'
const heading = computed(
  () =>
    schemeTransformer?.value.getSectionTitle(sekciaRefNazov) ||
    t('zoppm.step18.secondaryHeadingPO')
)
const specResponse = inject<VyzvaSpecificationPublicResponse>('specResponse')
let desc = t('zoppm.step18.descriptionPO')
specResponse?.zoppmSpec?.sekcie?.find((sekcia: any) => {
  if (sekcia.sekciaRef?.nazov === sekciaRefNazov) {
    desc = sekcia.instrukcie
      ? sekcia.instrukcie
      :  t('zoppm.step18.descriptionPO')
  }
})

</script>

<template>
  <IDSKHeading as="h1" variant="xl">{{ t('zoppm.step18.mainHeading') }}</IDSKHeading>
  <IDSKContainer>
    <IDSKHeading as="h1" variant="s">{{ heading }}</IDSKHeading>
    <IDSKParagraph v-html="desc"> </IDSKParagraph>
  </IDSKContainer>
</template>

<style lang="scss"></style>
